package services.http

import it.neckar.lizergy.model.project.previews.ProjectQueryComponent
import it.neckar.lizergy.model.project.previews.ProjectQueryForUser
import it.neckar.lizergy.model.project.process.state.LizergyProcessStates
import it.neckar.rest.RestResponse
import it.neckar.rest.pagination.Page
import it.neckar.rest.pagination.PaginationInfo
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for
 */
@Serializable
data class ProjectCountQueryRequest(
  val requestedProjectCountsForPhases: List<ProjectCountRequestForPhase>,
  val loggedInUser: UserLoginName,
)

@Serializable
data class ProjectCountRequestForPhase(
  val relevantProcessStates: List<@Serializable(with = LizergyProcessStatesSerializer::class) LizergyProcessStates>,
  val projectQueryComponent: ProjectQueryComponent?,
  val projectQueryForUser: ProjectQueryForUser,
)


@Serializable
sealed interface ProjectCountQueryResponse : RestResponse<List<ProjectCountForPhase>> {

  @Serializable
  @SerialName("good")
  data class Good(
    override val data: List<ProjectCountForPhase>,
    override val paginationInfo: PaginationInfo,
  ) : ProjectCountQueryResponse, RestResponse.PaginatedGoodResponse<List<ProjectCountForPhase>>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : ProjectCountQueryResponse, RestResponse.BadResponse<List<ProjectCountForPhase>>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: List<ProjectCountForPhase>, paginationInfo: PaginationInfo): ProjectCountQueryResponse = Good(data, paginationInfo)
    fun good(page: Page<ProjectCountForPhase>): ProjectCountQueryResponse = Good(page.pageElements, page.paginationInfo)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): ProjectCountQueryResponse = Failed
  }
}

@Serializable
data class ProjectCountForPhase(
  val projectQueryComponent: ProjectQueryComponent?,
  val projectCountForUser: Int,
  val totalProjectCount: Int,
)
